import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, CheckCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const { updatePassword } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const { error } = await updatePassword(password);
      if (error) {
        setError(error.message);
      } else {
        setSuccess(true);
        toast.success('Password updated successfully!');
        setTimeout(() => navigate('/'), 2000);
      }
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="app-container">
        <div className="app-wrapper">
          <div className="app-card">
            <div className="app-header">
              <h1>
                <CheckCircle className="header-icon" style={{ color: '#22c55e' }} />
                Password Updated
              </h1>
              <p>Your password has been reset successfully</p>
            </div>
            <div className="login-section">
              <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                Redirecting you to the app...
              </p>
              <Link to="/" className="btn btn-yellow btn-large">
                Go to App
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div className="app-wrapper">
        <div className="app-card">
          <div className="app-header">
            <div className="auth-mode-badge">NEW PASSWORD</div>
            <h1>
              <Lock className="header-icon" />
              Set New Password
            </h1>
            <p>Enter your new password below</p>
          </div>

          <div className="login-section">
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <Lock size={18} className="input-icon" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="New password"
                  className="auth-input"
                  required
                  minLength={6}
                />
              </div>

              <div className="input-group">
                <Lock size={18} className="input-icon" />
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  className="auth-input"
                  required
                  minLength={6}
                />
              </div>

              {error && <p className="auth-error">{error}</p>}

              <button type="submit" className="btn btn-yellow btn-large" disabled={loading}>
                {loading ? 'Updating...' : 'Update Password'}
              </button>
            </form>

            <div className="back-link">
              <Link to="/">Back to App</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
